import { render, staticRenderFns } from "./InvoiceList.vue?vue&type=template&id=20a7ca06&scoped=true"
import script from "./InvoiceList.vue?vue&type=script&lang=js"
export * from "./InvoiceList.vue?vue&type=script&lang=js"
import style0 from "./InvoiceList.vue?vue&type=style&index=0&id=20a7ca06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a7ca06",
  null
  
)

export default component.exports